export { default as Table } from './Table'
export { default as TableHead } from './TableHead'
export { default as TableBody } from './TableBody'
export { default as TableRow } from './TableRow'
export { default as TableCell } from './TableCell'
export { default as GenerateSkeleton } from './GenerateSkeleton'
